module.exports = __webpack_public_path__ + "img/C22.fd9ac91d.png";